/*
 *
 * BlogsDestinationPage actions
 *
 */

const SCOPE = 'app/BlogsDestinationPage/';
export const ActionTypes = {
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    RESET_PAGE: `${SCOPE}RESET_PAGE`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const resetPage = () => ({ type: ActionTypes.RESET_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});
